<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App',
    beforeCreate() {
      let lang = /(\?|&)lang=([^&]+)/.test(location.search) ? RegExp.$2 : navigator.language;
      if (lang) {
        lang = lang.split(/[\-_;,]/)[0].toLowerCase();
      }
      lang = 'zh';
      // 暂时不支持国际化 @21080727
      if (lang) {
        this.$store.commit('SET_LANG', lang)
        this._i18n.locale = lang;
      }
      // app or business
      if (this.$utils.isApp() || this.$utils.isBusiness()) {
        if (/android/i.test(navigator.userAgent)) {
          document.body.classList.add('android');
        }
        return document.body.classList.add('isApp');
      }
      if (this.$utils.isMobile()) {
        let app = document.getElementById('app');
        app.style['backgroundColor'] = '#fff';
        document.body.setAttribute('class', 'isMobile');
      } else {
        document.body.setAttribute('class', 'isPC');
      };
      var userInfo = this.$utils.isLogin();
      if (userInfo) {
        this.$store.commit("UPDATE_USERINFO", userInfo);
        this.$store.commit('UPDATE_CUR_BUSINESS', {
          role: userInfo.role,
          privileges: userInfo.privileges,
          id: userInfo.businessId,
          available: userInfo.available,
          valueAddInfos: userInfo.valueAddInfos
        });
        this.$router._initRouterByPermission()
      }
    },
    computed: {
      businessInfo() {
        return this.$store.state.businessInfo
      }
    }
  }

</script>

<style lang='less'>
  @import url('./assets/style/index.less');
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100%;
    display: flex;
    position: relative;
    >div {
      flex: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue